import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=d0ae74ba&scoped=true"
import script from "./signUp.vue?vue&type=script&lang=js"
export * from "./signUp.vue?vue&type=script&lang=js"
import style0 from "./signUp.vue?vue&type=style&index=0&id=d0ae74ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ae74ba",
  null
  
)

export default component.exports